import { defineComponent as _defineComponent } from 'vue'
import { onMounted, computed } from 'vue';

import BasicButton from '@/ui-components/BasicButton.vue';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { jwCheckIcon } from '@/plugins/global-fontawesome';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseModal',
  props: {
    title: null,
    subTitle: null,
    closable: { type: Boolean, default: true },
    position: { default: 'default' },
    hasHeader: { type: Boolean, default: true },
    hasDoneButton: { type: Boolean },
    disableDoneButton: { type: Boolean },
    onWillDismiss: { type: Function, default: () => Promise.resolve() }
  },
  emits: ["closed", "dismiss"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'closed'): void;
	(e: 'dismiss', data?: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { title?: string, subTitle?: string, closable: boolean, position: 'default' | 'bottom', hasHeader: boolean, hasDoneButton?: boolean, disableDoneButton?: boolean, onWillDismiss: () => Promise<void> };



const classes = computed(() => ['base-modal', { 'base-modal-bottom': props.position === 'bottom' }]);



onMounted(async () => {
	await props.onWillDismiss();
	emit('closed');
});

function close() {
	emit('dismiss');
	emit('closed');
}

return { __sfc: true,props, classes, emit, close, BasicButton, faTimes, jwCheckIcon }
}

})